import React from "react";
import * as S from "./styles";

const KIND_BADGE = {
  slow: "SLOW",
  freeze: "FREEZE",
  heart: "HEART",
  bombclear: "BOMB",
  danger: "DANGER",
};

const Word = ({ word, kind = "normal", x, y, isMatched, typingWord }) => {
  const clampedY = Math.min(Math.max(y, -20), 90);

  let correctCount = 0;
  if (isMatched) {
    for (let i = 0; i < typingWord.length && i < word.length; i++) {
      if (typingWord[i] === word[i]) correctCount++;
      else break;
    }
  }
  const progress = isMatched ? correctCount / word.length : 0;
  const scale = isMatched ? 1.1 + progress * 0.35 : 1;
  const glowStrength = 12 + progress * 38;

  const colorFor = (letter, i) => {
    if (!isMatched) return undefined;
    const typed = typingWord[i];
    if (typed == null) return undefined;
    if (typed === letter) return "var(--accent)";
    return "var(--danger)";
  };

  const shadowFor = (letter, i) => {
    if (!isMatched) return undefined;
    const typed = typingWord[i];
    if (typed == null) return undefined;
    if (typed === letter) return "0 0 8px var(--accent-glow)";
    return "0 0 8px var(--danger-glow)";
  };

  const classNames = ["word-box", `kind-${kind}`];
  if (isMatched) classNames.push("matched");
  if (progress >= 0.99) classNames.push("about-to-pop");

  return (
    <S.WordBox
      className={classNames.join(" ")}
      style={{
        left: `${x}%`,
        top: `${clampedY}%`,
        scale: String(scale),
        boxShadow: isMatched
          ? `0 0 0 1px var(--accent), 0 0 ${glowStrength}px var(--accent-glow), 0 6px 20px rgba(0,0,0,0.5)`
          : undefined,
      }}
    >
      {KIND_BADGE[kind] ? <S.KindBadge $kind={kind}>{KIND_BADGE[kind]}</S.KindBadge> : null}
      {word.split("").map((letter, i) => (
        <div className="letter-box" key={i}>
          <div
            className="letter"
            style={{ color: colorFor(letter, i), textShadow: shadowFor(letter, i) }}
          >
            {letter}
          </div>
        </div>
      ))}
    </S.WordBox>
  );
};

export default Word;
